
import { Component, Vue, Prop } from "vue-property-decorator";
import { formatUpyunUrl } from "@/utils";
@Component({
  components: {}
})
export default class CourseItem extends Vue {
  @Prop({ required: true }) private item!: any;

  formatUpyunUrl = formatUpyunUrl;
}
